import React from 'react';
import './index.css';
const Index = ({ image, name, number, percentage }) => {
    return (
        <div className="stats">
            <h2 className="stats_count">{number}</h2>
            <div className="stat_content">
                <img src={image} alt="icon" className="stat_icon" />
                <p className="stat_name">{name}</p>
                <p className="stat_pecentage">+{percentage}%</p>
            </div>
        </div>
    );
};

export default Index;
